import React from "react";
import { motion } from "framer-motion";
import { Plane, Stamp, Hotel, UtensilsCrossed, Star, Download, ArrowRight } from "lucide-react";
import { PACKAGES } from "@/data/content";

const ICONS = {
  Flights: Plane,
  Visa: Stamp,
  Hotels: Hotel,
  Meals: UtensilsCrossed,
};

export default function Packages({ onBook }) {
  return (
    <section id="packages" className="py-24 md:py-32 bg-white px-6 lg:px-10" data-testid="packages-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#C9A227]" />
              <span className="overline">Featured Packages</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A2342] max-w-2xl">
              Six journeys our concierge can't stop recommending.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {PACKAGES.map((p, i) => (
            <motion.div
              key={p.id}
              data-testid={`package-${p.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className="lux-card p-3"
            >
              <div className="relative overflow-hidden rounded-2xl aspect-[4/3]">
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out hover:scale-110"
                />
                <div className="absolute top-3 left-3 glass rounded-full px-3 py-1.5 flex items-center gap-1 text-xs font-medium text-[#0A2342]">
                  <Star className="w-3 h-3 fill-[#C9A227] text-[#C9A227]" />
                  {p.rating}
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-display text-xl text-[#0A2342] leading-tight">{p.name}</h3>
                </div>
                <p className="mt-1 text-sm text-[#6B7280]">{p.duration}</p>

                <div className="mt-4 flex gap-1.5 flex-wrap">
                  {p.inclusions.map((b) => {
                    const Ico = ICONS[b];
                    return (
                      <span
                        key={b}
                        className="text-[11px] font-medium bg-[#F8F9FB] text-[#154C79] px-2.5 py-1.5 rounded-full inline-flex items-center gap-1.5 border border-gray-100"
                      >
                        {Ico ? <Ico className="w-3 h-3" /> : null}
                        {b}
                      </span>
                    );
                  })}
                </div>

                <div className="mt-5 pt-5 border-t border-gray-100 flex items-end justify-between">
                  <div>
                    <div className="text-[11px] uppercase tracking-[0.18em] text-[#6B7280]">Starting from</div>
                    <div className="font-display text-2xl text-[#0A2342]">{p.price}</div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      data-testid={`book-${p.id}`}
                      onClick={() => onBook(p)}
                      className="btn-navy text-sm py-2 px-4"
                    >
                      Book <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
